/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { Fragment, useState, useEffect } from 'react';
// import { useDispatch } from "react-redux";
// import { useHistory } from "react-router-dom";

import { Divider, Row, Col } from 'antd';
import { Card, Icon } from 'pnnl-react-core';
import { Grid, Popover, OverlayTrigger } from 'react-bootstrap';
// import { DeleteOutlined } from "@ant-design/icons";

import Examples from 'components/sections/examples';
import FileInput from 'components/sections/fileInput';
import Paste from 'components/sections/paste';
// import MultipleCalc from "components/multipleCalculator";
// import SharedModal from "components/modal";

// import { clearLibraryData, setLibraryData } from "redux/actions";

const Calculator = () => {
  // const dispatch = useDispatch();
  // const history = useHistory();
  // const storedLibraryData = JSON.parse(localStorage.getItem("myLibrary"));

  const [view, setView] = useState('examples');
  // const [addNewLibraryModal, setAddNewLibraryModal] = useState(false);
  // const [loadLibraryConfirmModal, setLoadLibraryConfirmModal] = useState(false);
  // const [deleteLibraryConfirmModal, setDeleteLibraryConfirmModal] = useState(
  //   false
  // );
  // const [selectedLibData, setSelectedLibData] = useState(null);

  const handleViewChange = (value) => {
    setView(value);
  };

  const popOverInfo = (
    <Popover id='popover-trigger-hover-focus' title='What is a SPDX file?'>
      SPDX files are defined in IES TM-27-14: Standard File Format for the
      Electronic Transfer of Spectral Data. SPDX files can be generated using
      this tool for any library entry.
    </Popover>
  );

  // const loadLibrary = () => {
  //   const { libraryInfo, libraryData } = selectedLibData;
  //   dispatch(clearLibraryData());
  //   libraryData.forEach((data, index) => {
  //     dispatch(setLibraryData(libraryInfo[index], data));
  //   });
  //   history.push({
  //     pathname: "/user-library"
  //   });
  // };

  // const handleDeleteLibrary = () => {
  //   setSelectedLibData(null);
  //   let librarySelect = document.getElementById("library-select");
  //   const targetIndex = librarySelect.selectedIndex;
  //   storedLibraryData.splice(targetIndex - 1, 1);
  //   localStorage.setItem("myLibrary", JSON.stringify(storedLibraryData));
  //   setDeleteLibraryConfirmModal(false);
  // };

  // const addNewModalContainer = (
  //   <SharedModal
  //     isOpen={addNewLibraryModal}
  //     onClose={() => setAddNewLibraryModal(false)}
  //     title="Add new item to library"
  //     body={<MultipleCalc />}
  //     buttons={[
  //       {
  //         name: "Close",
  //         clickHandler: () => setAddNewLibraryModal(false),
  //         bsStyle: ""
  //       }
  //     ]}
  //   />
  // );

  // const libraryConfirmModal = (
  //   <SharedModal
  //     isOpen={loadLibraryConfirmModal}
  //     onClose={() => setLoadLibraryConfirmModal(false)}
  //     title="Add new item to library"
  //     body="  Existing library will be overwritten. Are you sure you want to
  //     proceed?"
  //     buttons={[
  //       {
  //         name: "Close",
  //         clickHandler: () => setLoadLibraryConfirmModal(false),
  //         bsStyle: ""
  //       },
  //       {
  //         name: "Proceed",
  //         clickHandler: loadLibrary,
  //         bsStyle: "primary"
  //       }
  //     ]}
  //   />
  // );

  // const deleteLibraryConfirmationModal = (
  //   <SharedModal
  //     isOpen={deleteLibraryConfirmModal}
  //     onClose={() => setDeleteLibraryConfirmModal(false)}
  //     title="Delete saved library"
  //     body=" Are you sure you want to delete the library?"
  //     buttons={[
  //       {
  //         name: "Close",
  //         clickHandler: () => setDeleteLibraryConfirmModal(false),
  //         bsStyle: ""
  //       },
  //       {
  //         name: "Delete",
  //         clickHandler: handleDeleteLibrary,
  //         bsStyle: "danger"
  //       }
  //     ]}
  //   />
  // );

  // const savedOptions = storedLibraryData?.map((libData, index) => {
  //   return (
  //     <option
  //       data-icon={<DeleteOutlined />}
  //       key={index}
  //       value={JSON.stringify(libData.value)}
  //     >
  //       {libData.label}
  //       {/* {<i class="fa fa-home"></i>} */}
  //       {/* <DeleteOutlined /> */}
  //     </option>
  //   );
  // });

  // const userLibraryInfo = (
  //   <Popover id="popover-trigger-hover-focus" title="Use of User SPD Library">
  //     Visit the User Library page to upload new SPDs for batch processing.
  //     Library files can be downloaded and shared.
  //   </Popover>
  // );

  // const userLibrary = (
  //   <div>
  //     <h2>Create a User SPD Library</h2>
  //     <Button
  //       onClick={() => setAddNewLibraryModal(true)}
  //       style={{ marginTop: "10px" }}
  //       bsStyle="success"
  //       bsSize="small"
  //     >
  //       Add new item(s)
  //     </Button>
  //     {addNewModalContainer}
  //     <h5>
  //       Saved user libraries{" "}
  //       {
  //         <OverlayTrigger
  //           trigger={["hover", "focus"]}
  //           placement="right"
  //           overlay={userLibraryInfo}
  //         >
  //           <span css={styles.infoIcon}>
  //             <Icon icon="info" />
  //           </span>
  //         </OverlayTrigger>
  //       }
  //     </h5>
  //     <select
  //       css={styles.select}
  //       id="library-select"
  //       style={{ width: "28rem" }}
  //       onChange={event =>
  //         event.target.value === ""
  //           ? setSelectedLibData(null)
  //           : setSelectedLibData(JSON.parse(event.target.value))
  //       }
  //     >
  //       <option value="">Choose an Library</option>
  //       {savedOptions}
  //     </select>
  //     <div style={{ display: "flex" }}>
  //       <Button
  //         onClick={() => setLoadLibraryConfirmModal(true)}
  //         style={{ marginTop: "10px" }}
  //         bsStyle="primary"
  //         bsSize="small"
  //         disabled={selectedLibData === null}
  //       >
  //         Load library
  //       </Button>
  //       <Button
  //         onClick={() => setDeleteLibraryConfirmModal(true)}
  //         style={{ marginTop: "10px", marginLeft: "10px" }}
  //         bsStyle="danger"
  //         bsSize="small"
  //         disabled={selectedLibData === null}
  //       >
  //         Delete Library
  //       </Button>
  //     </div>
  //     {libraryConfirmModal}
  //     {deleteLibraryConfirmationModal}
  //   </div>
  // );

  return (
    <Grid css={styles.calculator}>
      <Card css={styles.calculatorCard}>
        <Row>
          <Col css={styles.menuItems(view)}>
            <div id='examples' onClick={() => handleViewChange('examples')}>
              <h3>Call from Library</h3>
              <Examples view={view} />
            </div>
            <Divider css={styles.dividerStyles} />
            <div id='import' onClick={() => handleViewChange('import')}>
              <h3>
                Import SPDX{' '}
                {
                  <OverlayTrigger
                    trigger={['hover', 'focus']}
                    placement='right'
                    overlay={popOverInfo}
                  >
                    <span css={styles.infoIcon}>
                      <Icon icon='info' />
                    </span>
                  </OverlayTrigger>
                }
              </h3>
              <FileInput view={view} />
            </div>
            <Divider css={styles.dividerStyles} />
            <div id='paste' onClick={() => handleViewChange('paste')}>
              <h3>Paste Data</h3>
              <Paste view={view} />
            </div>
          </Col>
        </Row>
      </Card>
    </Grid>
  );
};

export default Calculator;

const styles = {
  calculator: css`
    width: 45rem;
    height: 84rem;
    float: left;
    position: relative;
    top: 5rem;
    margin: 0 30rem;

    @media (max-width: 1800px) {
      margin: 0 25rem;
    }

    @media (max-width: 1700px) {
      margin: 0 20rem;
    }

    @media (max-width: 1650px) {
      margin: 0 15rem;
    }

    @media (max-width: 1550px) {
      margin: 0 10rem;
    }

    @media (max-width: 1500px) {
      margin: 0 5rem;
    }

    @media (max-width: 1400px) {
      margin: 0;
    }
  `,
  calculatorCard: css`
    border-radius: 2rem;
  `,
  activeItemBaseStyle: css`
    border-left: 7px solid #d77600;
    margin-left: -15px;
    padding-left: 1rem;
  `,
  menuItems: (view) => css`
    display: grid;
    height: 72rem;

    #examples,
    #import,
    #paste {
      &:hover,
      &:focus {
        border-left: 7px solid rgb(215, 118, 0, 0.4);
        margin-left: -15px;
        padding-left: 1rem;
      }
    }

    #examples {
      ${view === 'examples' &&
      css`
        ${styles.activeItemBaseStyle}
        &:hover,
        &:focus {
          border-color: #d77600;
        }
        border-top-left-radius: 7px;
      `}

      &:hover,
      &:focus {
        border-top-left-radius: 7px;
      }
    }

    #import {
      ${view === 'import' &&
      css`
        ${styles.activeItemBaseStyle}
        &:hover,
        &:focus {
          border-color: #d77600;
        }
      `}
    }

    #paste {
      ${view === 'paste' &&
      css`
        ${styles.activeItemBaseStyle}
        &:hover,
        &:focus {
          border-color: #d77600;
        }
        border-bottom-left-radius: 7px;
      `}

      &:hover,
      &:focus {
        border-bottom-left-radius: 7px;
      }
    }
  `,
  description: css`
    position: absolute;
    top: 50px;
    left: 216px;
    font-size: 18px;
    font-weight: 400;
  `,
  infoIcon: css`
    font-size: 16px;
    color: #47494c;
    opacity: 0.7;
  `,
  select: css`
    border-radius: 4px;
    border: 1px solid cccccc;
    padding: 8px;
  `,
  dividerStyles: css`
    margin: 4px 0;
  `,
  // numberMarkerStyle: css`
  //   height: 4rem;
  //   width: 4rem;
  //   background-color: #d77600;
  //   border: 3px solid black;
  //   border-radius: 50%;
  //   display: inline-block;
  //   padding 0 9px;
  // `,
};

{
  /* <Card css={styles.calculatorCard}>
  <Row>
    <Col md={12} css={styles.menuItems}>
      <Row>
        <Col
          css={styles.activeElement(view === 'examples', view)}
          onClick={() => handleViewChange('examples')}
          md={10}
        >
          <h2>
            Call from Library
          </h2>
          <Examples view={view} />
        </Col>
      </Row>
      <Divider css={styles.dividerStyles} />
      <Row>
        <Col
          md={10}
          css={styles.activeElement(view === 'import', view)}
          onClick={() => handleViewChange('import')}
        >
          <h2>
            Import SPDX{' '}
            {
              <OverlayTrigger
                trigger={['hover', 'focus']}
                placement="right"
                overlay={popOverInfo}
              >
                <span css={styles.infoIcon}>
                  <Icon icon="info" />
                </span>
              </OverlayTrigger>
            }
          </h2>
          <FileInput view={view} />
        </Col>
      </Row>
      <Divider css={styles.dividerStyles} />
      <Row>
        <Col
          css={styles.activeElement(view === 'paste', view)}
          onClick={() => handleViewChange('paste')}
          md={10}
        >
          <h2>Paste Data</h2>
          <Paste view={view} />
        </Col>
      </Row>
    </Col>
  </Row>
</Card> */
}
